import React, { useEffect } from "react";
import { AddCircleIcon } from "../../constant";
import Button from "../Button";
import SlotForm from "../SlotForm";
import classes from "./SlotsTable.module.css";
// Create an empty slot object helper
const createEmptySlot = () => null;
// Initialize with 2 empty slots by default
const SlotsTableModal = ({
  slots = [],
  onChange = () => {},
  onAdd,
  editMode,
 
}) => {
  // Ensure slots array has valid objects (no nulls)
  let normalizedSlots = slots?.length > 0 ? slots : [];
  useEffect(() => {
    normalizedSlots = slots?.length > 0 ? slots : [];
    if (slots?.length > 0) {
      normalizedSlots = slots;
    }
  }, [slots]);

  console.log("normalizeSlots", normalizedSlots);
  // Safe function to call onChange only if it's a function
  const safeOnChange = (updatedSlots) => {
    if (typeof onChange === "function") {
      onChange(updatedSlots);
    }
  };
  const handleDelete = (index) => {
    const updatedSlots = [...normalizedSlots];
    updatedSlots.splice(index, 1);
    onChange(updatedSlots);
  };
  const handleAddSlot = () => {
    if (typeof onAdd === "function") {
      onAdd(createEmptySlot());
      return;
    }
    // Fallback to using onChange
    const updatedSlots = [...normalizedSlots, createEmptySlot()];
    safeOnChange(updatedSlots);
  };

  return (
    <section className={classes.slotsTableWrapper}>
      <div className={classes.actionContainer}>
        <h2 className={classes.title}>Pricing</h2>
        <Button
          variant="secondary"
          className={classes.addButton}
          onClick={handleAddSlot}
          label="Add Slot"
          leftIcon={<AddCircleIcon className={classes.icon} />}
        />
      </div>

      <div className={classes.slotsTableWrapper}>
        {normalizedSlots.map((slot, index) => (
          <SlotForm
            slotsArray={slots}
            editMode={editMode}
            key={index}
            slot={slot}
            value={normalizedSlots}
            onDelete={handleDelete}
            index={index}
            onChange={onChange}
          />
        ))}

        {normalizedSlots.length === 0 && (
          <div className={classes.emptyState}>
            No slots added yet. Click "Add Slot" to create one.
          </div>
        )}
      </div>
    </section>
  );
};

export default SlotsTableModal;
